<template>
  <v-layout row justify-end>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationAddUserDetailDialog.addTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="clearForm()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout pa-5>
              <v-flex xs12>
                <v-text-field label="Username" v-model="username" :rules="nameRules"></v-text-field>
                <v-text-field label="Password" v-model="password" :rules="passwordRules" type="password"></v-text-field>
                <v-text-field label="Confirm Password" v-model="confirmPassword" :rules="comfirmRules" type="password"></v-text-field>
                <v-text-field label="Email" v-model="email" :rules="emailRules"></v-text-field>
                <v-autocomplete label="Tenant" v-model="userRole" :items="activeTenantNames" :rules="[v => !!v || 'Tenant is required']" required></v-autocomplete>
                <v-checkbox v-model="isSysAdmin" :label="'Is System Administrator'"></v-checkbox>
                <v-checkbox v-model="isTenantAdmin" :label="'Is Tenant Administrator'"></v-checkbox>
                <v-switch v-model="enableTwoFactor" :label="'Enable Two factor authentication'"></v-switch>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submit()">
              <v-icon>done</v-icon>
              {{ $t('Button.Create') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const {
    mapGetters,
    mapActions,
  } = createNamespacedHelpers('admin')

  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialog: '',
        snackbar: '',
        snackColor: '',
        snackMessage: '',
        valid: true,

        username: '',
        password: '',
        confirmPassword: '',
        email: '',
        userRole: null,
        isSysAdmin: false,
        isTenantAdmin: false,
        enableTwoFactor: false,

        nameRules: [
          (v) => !!v || 'User name is required',
          (v) => this.userList.find(x => x.UserName == v) == null || 'The user name already exists',
        ],
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
        passwordRules: [
          (v) => !!v || 'Password is required',
          (v) => v && v.length >= 6 || 'Passwords must contain at least 6 characters',
        ],
        comfirmRules: [
          (v) => this.password == v || 'Passwords do not match',
        ],
      }
    },
    mounted() {},
    computed: {
      ...mapGetters(['roleList', 'userList']),
      activeTenantNames() {
        return this.roleList.filter(tenant => !tenant.IsArchived).map(tenant => tenant.RoleName)
      },
    },
    watch: {
      show() {
        this.dialog = true
      },
    },
    methods: {
      ...mapActions(['postAddUser']),
      submit() {
        if (this.$refs.form.validate()) {
          let options = {
            data: {
              UserName: this.username,
              Password: this.password,
              ConfirmPassword: this.confirmPassword,
              Email: this.email,
              Role: this.userRole,
              IsSysAdmin: this.isSysAdmin,
              IsTenantAdmin: this.isTenantAdmin,
              EnableTwoFactor: this.enableTwoFactor,
            },
            successCb: () => {
              this.snackMessage = this.$t('AdministrationAddUserDetailDialog.addSuccessMsg', { msg: this.username })
              this.snackColor = 'success'
              this.snackbar = true
              this.clearForm()
            },
            failedCb: (err) => {
              this.snackColor = 'error'
              this.snackMessage = err
              this.snackbar = true
            },
          }
          this.postAddUser(options)
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.dialog = false
      },
    },
  }
</script>